import React, { Fragment } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import SocialButton from "../../UI/SocialButton/SocialButton";
import { isCordovaApp } from "../../../utils/cordovaUtils";
import VerseActionPopover from "./VerseActionPopover";

const PopoverPositioner = styled.div`
  position: absolute;
  z-index: 1100;
  transform: ${({ top, left }) => `translate(${left || 0}px, ${top || 0}px)`};
  transition: transform 75ms ease-out;
`;

const Popover = ({
  position: { top, left },
  bibleId,
  chapterRef,
  currentChapterRef,
  selectedVerseOrgIds
}) => {
  // if the current viewed chapter is different than the chapter when
  // the pop over was clicked, do not render the Popover
  // or if there isn't a selected verse(s)
  if (
    !chapterRef ||
    currentChapterRef !== chapterRef ||
    selectedVerseOrgIds.length === 0
  ) {
    return null;
  }

  return (
    <PopoverPositioner top={top} left={left}>
      <VerseActionPopover
        bibleId={bibleId}
        selectedVerseOrgIds={selectedVerseOrgIds}
        render={({ url, message }) => (
          <div key="social-wrap" style={{ textAlign: "center" }}>
            {!isCordovaApp && (
              <Fragment>
                <SocialButton
                  key="twitter"
                  socialType="twitter"
                  message={message}
                  url={url}
                />
                <SocialButton
                  key="facebook"
                  socialType="facebook"
                  message={message}
                  url={url}
                />
              </Fragment>
            )}
            {isCordovaApp && (
              <SocialButton
                key="cordova"
                socialType="cordova"
                message={message}
                url={url}
              />
            )}
            <SocialButton
              key="link-copy"
              socialType="link-copy"
              url={url}
              message={message}
            />
            <SocialButton
              key="verse-copy"
              socialType="verse-copy"
              message={message}
              url={url}
            />
          </div>
        )}
      />
    </PopoverPositioner>
  );
};

Popover.propTypes = {
  bibleId: PropTypes.string.isRequired,
  chapterRef: PropTypes.string.isRequired,
  currentChapterRef: PropTypes.string,
  selectedVerseOrgIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  position: PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number
  }).isRequired
};

Popover.defaultProps = {
  currentChapterRef: null
};

export default Popover;
